import Tabs from "components/lib/Shared/Tabs";
import React, { useContext, useEffect, useRef, useState } from "react";
import { useHistory } from "react-router-dom";
import ShareCapital from "./AllotmentTabs/ShareCapital";
import TypeOfChange from "./AllotmentTabs/TypeOfChange";
import CompanyOfficial from "./AllotmentTabs/CompanyOfficial";
import BeneficialOwners from "./AllotmentTabs/BeneficialOwners";
import ResolutionsDirectors from "./AllotmentTabs/Resolutions";
import Shareholders from "./AllotmentTabs/Shareholders";
import Status from "./AllotmentTabs/Status";
import AllotmentForm from "./AllotmentForms/allotmentForm";
import ChangesContext from "context/ChangesContext";
import { ChevronLeftIcon } from "@heroicons/react/solid";
import { useSelector, useDispatch } from "react-redux";
import AddSharesOnOffer from "./AllotmentForms/addSharesOnOfferForm";
import {
  addShareAllotmentAsync,
  submitAllotmentsAsync,
  applyProRataAsync,
  applyRightsIssueAsync,
  applyGeneralOfferAsync,
} from "./../../../../../../state/slices/shareCapitalAllotment";
import { useToast } from "hooks/useToast";
import {
  getAllInitiateTransactionChangeAsync,
  editInitiatedTransactionChangeAsync,
} from "state/slices/initiateTransactionChange";
import { handleCompanyMaintenanceFormData } from "utils/transactionRequestHandler";
import { Constants } from "config/constants";

const AllotmentOfShares = (props) => {
  const { toast } = useToast(5000);
  const shareCapitalRef = useRef();
  const history = useHistory();
  const dispatch = useDispatch();

  const { company } = useSelector((state) => state.companyDashboardSlice);
  const companyId = company._id;
  const shareAllotments = useSelector(
    (state) => state.shareAllotmentSlice?.allotments || []
  );
  const shareAuthorization = useSelector(
    (state) => state.shareAuthorizationSlice
  );

  const companyOfficialsSlice =
    useSelector((state) => state.companyOfficialsSlice) || {};
  const officials = companyOfficialsSlice.companyOfficials?.items || [];

  const filteredOfficials = officials.filter((official) =>
    [
      Constants.APPLICANT_CAPACITIES.SHAREHOLDER,
      Constants.APPLICANT_CAPACITIES.JOINT_SHAREHOLDER,
      Constants.APPLICANT_CAPACITIES.DIRECTOR_SHAREHOLDER,
    ].includes(official.designation)
  );

  const hasProposedAllotment = shareAllotments.length > 0;
  const hasProposedAuthorization = shareAuthorization.totalCount > 0;

  let preEmptionRights = useSelector(
    (state) => state.shareAllotmentSlice.preEmptionRights
  );

  if (company.type === "PLC") {
    preEmptionRights = "waived";
  }

  const initialTabs = React.useMemo(
    () => [
      {
        id: "typeOfChange",
        label: "Type Of Change",
      },
      { id: "shareCapital", label: "Share Capital" },
    ],
    []
  );
  const { isBackFromChangesTable, selectedChangeProcess } =
    useContext(ChangesContext);
  const [tabs, setTabs] = useState(initialTabs);
  const [selectedTabIndex, setSelectedTabIndex] = useState(
    isBackFromChangesTable && selectedChangeProcess.id === "ShareCapital"
      ? tabs.length - 1
      : 0
  );
  const [selectedTab, setSelectedTab] = useState(tabs[selectedTabIndex]);
  const [isLastStep, setIsLastStep] = useState(false);
  const [typeOfChange, setTypeOfChange] = useState(null);
  const [showAllotmentForm, setShowAllotmentForm] = useState(false);
  const [selectedOption, setSelectedOption] = useState(null);
  const [showRightsIssueView, setShowRightsIssueView] = useState(false);
  const [showAddSharesForm, setShowAddSharesForm] = useState(false);
  const [formData, setFormData] = useState();
  const [submittedAllocations, setSubmittedAllocations] = useState([]);
  const [isSyncingAfterUpdate, setIsSyncingAfterUpdate] = useState(false);
  const [createdTransactionsIds, setCreatedTransactionsIds] = useState([]);
  const [selectedChangeType, setSelectedChangeType] = useState("");

  const handleGoToNextStep = async () => {
    // Handle shareCapital tab submission
    if (
      selectedTab?.id === "shareCapital" &&
      typeOfChange === "authorization" &&
      !showAddSharesForm &&
      !showAllotmentForm
    ) {
      const success = await shareCapitalRef.current?.submit?.();
      if (!success) return;
    }

    if (selectedTab?.id === "beneficialOwners") {
      const success = await handleAllotmentTransactionSubmit("proceed");
      if (!success) return;
    }

    // Navigation logic
    if (selectedTabIndex + 1 === tabs.length) {
      // Logic for last tab
    } else {
      setSelectedTabIndex((prev) => prev + 1);
    }
  };

  const handleGoToPrevStep = () => {
    if (selectedTabIndex === 0) {
      alert("on first");
    } else {
      if (selectedTabIndex === 1) {
        setTabs(initialTabs);
      }
      setSelectedTabIndex((prev) => prev - 1);
    }
  };

  const handleRightsToIssueClick = () => {
    setShowAllotmentForm(true);
  };

  const handleAddSharesClick = () => {
    if (selectedTab.id === "shareCapital") {
      setShowAddSharesForm(true);
    }
  };

  const handleAllocateSharesProRataClick = async () => {
    const option = "proRata";

    try {
      const response = await dispatch(
        applyProRataAsync({ shareAllotments, option, companyId })
      );
      if (response.payload) {
        toast("success", response.payload.message);
        if (selectedTabIndex + 1 < tabs.length) {
          setSelectedTabIndex((prev) => prev + 1);
        }
      } else {
        toast(
          "error",
          response.payload?.message || "An unexpected error occurred"
        );
      }
    } catch (error) {
      toast("error", error.message || "Failed to process the pro-rata request");
    }
  };

  const handleAddSpecificShareholderClick = () => {};

  const deleteAllocationFromTransaction = async ({
    classOfShares,
    sharesOnOffer,
    option,
  }) => {
    setIsSyncingAfterUpdate(true);
    try {
      let processType = "unallotedShares";
      if (selectedChangeType.includes("privateWithMoreThanOneClass"))
        processType = "privateWithMoreThanOneClass";
      else if (selectedChangeType.includes("PVTwithOneClass"))
        processType = "PVTwithOneClass";

      const fetchAction = await dispatch(
        getAllInitiateTransactionChangeAsync({
          companyId,
          params: {
            transactionType: Constants.TRANSACTION_TYPES.MANUAL,
            processType,
            ...(createdTransactionsIds.length > 0 && {
              transactionIds: createdTransactionsIds,
            }),
          },
        })
      );

      const txs = fetchAction?.payload?.items || [];
      const target = txs.find((tx) => tx.processType === processType);
      if (!target?._id)
        throw new Error(`No existing '${processType}' transaction found.`);

      const updatedShareCapitalChanges = (
        target.shareCapitalChanges || []
      ).filter(
        (change) =>
          !(
            change.classOfShares === classOfShares &&
            Number(change.sharesOnOffer) === Number(sharesOnOffer) &&
            change.option === option
          )
      );

      const updatePayload = {
        companyId,
        documentId: target._id,
        formName: "initiateTransactionChange",
        shareCapitalChanges: updatedShareCapitalChanges,
      };

      const txUpdate = await handleCompanyMaintenanceFormData(
        "existing-request",
        updatePayload,
        companyId
      );

      if (
        txUpdate.type !==
        "transactionChange/editInitiatedTransactionChangeAsync/fulfilled"
      ) {
        const msg =
          txUpdate?.payload?.messageText ||
          "Failed to delete allocation from transaction.";
        throw new Error(msg);
      }

      await dispatch(
        getAllInitiateTransactionChangeAsync({
          companyId,
          params: {
            transactionType: Constants.TRANSACTION_TYPES.MANUAL,
            ...(createdTransactionsIds.length > 0 && {
              transactionIds: createdTransactionsIds,
            }),
          },
        })
      );

      setSubmittedAllocations((prev) =>
        (prev || []).filter(
          (a) =>
            !(
              a.classOfShares === classOfShares &&
              Number(a.sharesOnOffer) === Number(sharesOnOffer) &&
              a.option === option
            )
        )
      );

      toast("success", "Allocation deleted.");
    } catch (e) {
      toast("error", e?.message || "Failed to delete allocation.");
    } finally {
      setIsSyncingAfterUpdate(false);
    }
  };

  const handleAllotmentTransactionSubmit = async (option) => {
    try {
      const submissionData = {
        companyId,
        shareAllotments: shareAllotments,
      };

      const resultAction = await dispatch(
        submitAllotmentsAsync(submissionData)
      );

      if (submitAllotmentsAsync.fulfilled.match(resultAction)) {
        const response = resultAction.payload;
        const trxId = response.data.updatedAllotments[0]?.trxId;
        const message =
          response?.message || "Share allotments submitted successfully";
        toast("success", message);
        history.push(
          `/companies/${submissionData.companyId}/dashboard/transactions/${trxId}/recent-changes`
        );
        return true;
      } else {
        const errorPayload = resultAction.payload;
        let errorMessage;

        if (
          errorPayload &&
          typeof errorPayload === "object" &&
          errorPayload.message
        ) {
          errorMessage = errorPayload.message;
        } else if (errorPayload && typeof errorPayload === "string") {
          errorMessage = errorPayload;
        } else {
          errorMessage = "Failed to submit share allotments. Please try again.";
        }

        toast("error", errorMessage);
        return false;
      }
    } catch (error) {
      const errorMessage =
        error.message ||
        "An unexpected error occurred during submission. Please try again.";
      toast("error", errorMessage);
      return false;
    }
  };

  const hideAllotmentForm = () => {
    setShowAllotmentForm(false);
    setSelectedOption(null);
  };

  const hideAddSharesForm = () => {
    setShowAddSharesForm(false);
  };

  //rights isse and general offer submission function
  const handleAllotmentFormSubmit = async (data, { setSubmitting }) => {
    const { option } = data;
    try {
      let response;
      if (option === "rightsIssue") {
        response = await dispatch(
          applyRightsIssueAsync({ ...data, shareAllotments, companyId })
        );
      } else {
        response = await dispatch(
          applyGeneralOfferAsync({ ...data, shareAllotments, companyId })
        );
      }

      // Check if the action was rejected (status: false)
      if (response.error) {
        toast("error", response.payload || "Failed to process the request");
        setSubmitting(false); // Stop the spinner
        return; // Do not proceed to the next tab
      }

      // Handle successful response (status: true)
      if (response.payload && response.payload.status) {
        toast("success", response.payload.message || "Allotment successful");
        if (option === "rightsIssue") {
          setShowRightsIssueView(true);
          setShowAllotmentForm(false);
        } else {
          setShowAllotmentForm(false);
        }
        if (selectedTabIndex + 1 < tabs.length) {
          setSelectedTabIndex((prev) => prev + 1);
        }
      } else {
        // Fallback for unexpected payload structure
        toast(
          "error",
          response.payload?.message || "An unexpected error occurred"
        );
        setSubmitting(false); // Stop the spinner
      }
    } catch (error) {
      toast("error", error.message || "An unexpected error occurred");
      setSubmitting(false); // Stop the spinner
    }
  };

  const handleAddSharesOnOfferFormSubmit = async (data) => {
    const updatedData = {
      ...data,
      companyId: company._id,
    };
    const resultAction = await dispatch(addShareAllotmentAsync(updatedData));
    if (addShareAllotmentAsync.fulfilled.match(resultAction)) {
      const response = resultAction.payload;
      const message =
        response.message || "Share allotment created successfully";
      toast("success", message);
      setShowAddSharesForm(false);
    } else {
      const errorMessage =
        resultAction.payload || "Failed to create share allotment";
      toast("error", errorMessage);
    }
    setShowAddSharesForm(false);
  };
  const resetTabsBasedOnType = (type) => {
    let newTabs = [];
    switch (type) {
      case "authorization":
        newTabs = [
          { id: "typeOfChange", label: "Type Of Change" },
          { id: "shareCapital", label: "Share Capital" },
        ];
        break;
      case "unallotedShares":
        newTabs = [
          { id: "typeOfChange", label: "Type Of Change" },
          { id: "shareCapital", label: "Share Capital" },
          { id: "companyOfficial", label: "Company Official" },
          { id: "beneficialOwners", label: "Beneficial Owners" },
        ];
        break;
      case "privateWithOneClass":
      case "privateWithMoreThanOneClass":
        newTabs = [
          { id: "typeOfChange", label: "Type Of Change" },
          { id: "shareCapital", label: "Share Capital" },
          { id: "companyOfficial", label: "Company Official" },
          { id: "beneficialOwners", label: "Beneficial Owners" },
        ];
        break;
      default:
        newTabs = initialTabs;
    }
    return newTabs;
  };
  const handleTypeOfChangeSelection = (type) => {
    setTypeOfChange(type);
    setSelectedChangeType(type);
    setTabs(resetTabsBasedOnType(type));
    handleGoToNextStep();
  };

  const renderBottomButtons = () => {
    if (
      selectedTab.id !== "shareCapital" ||
      showAddSharesForm ||
      showAllotmentForm
    ) {
      return (
        <button
          onClick={handleGoToNextStep}
          className="bg-sflPrimary p-2 px-6 rounded text-white"
        >
          Proceed
        </button>
      );
    }

    const isCompanyPvt = company.type === "PVT";
    const isCompanyPlc = company.type === "PLC";

    // Handle authorization type of change
    if (typeOfChange === "authorization") {
      // Only show Proceed button if has proposed authorization
      if (hasProposedAuthorization) {
        return (
          <button
            onClick={handleGoToNextStep}
            className="bg-sflPrimary p-2 px-6 rounded text-white"
          >
            Proceed
          </button>
        );
      } else {
        return null;
      }
    }

    // Handle unallotedShares type of change
    else if (typeOfChange === "unallotedShares") {
      // For PVT companies with proposed shares, handle all preEmptionRights cases
      if (hasProposedAllotment && isCompanyPvt) {
        // Case: preEmptionRights is null, undefined, or empty string
        if (!preEmptionRights) {
          return null;
        }

        // Case: preEmptionRights is "applies"
        if (preEmptionRights === "applies") {
          return (
            <button
              onClick={handleAllocateSharesProRataClick}
              className="bg-[#31415d] p-3 px-4 rounded text-white"
            >
              Allocate shares Pro Rata
            </button>
          );
        }

        // Case: preEmptionRights is "waived"
        if (preEmptionRights === "waived") {
          return (
            <button
              onClick={handleAddSpecificShareholderClick}
              className="bg-sflPrimary p-3 px-4 rounded text-white"
            >
              Add specific shareholder
            </button>
          );
        }
      }

      // No proposed shares for any company type
      if (!hasProposedAllotment) {
        return (
          <button
            onClick={handleAddSharesClick}
            className="bg-[#31415d] p-3 px-4 rounded text-white"
          >
            Add shares on offer
          </button>
        );
      }
      // For PLC with proposed shares
      if (hasProposedAllotment && isCompanyPlc) {
        return (
          <button
            onClick={handleAddSpecificShareholderClick}
            className="bg-sflPrimary p-3 px-4 rounded text-white"
          >
            Add specific shareholder
          </button>
        );
      }
    }
    //handle private with one class type of change
    else if (
      typeOfChange === "privateWithOneClass" &&
      isCompanyPvt &&
      hasProposedAllotment
    ) {
      return (
        <button
          onClick={handleAllocateSharesProRataClick}
          className="bg-[#31415d] p-3 px-4 rounded text-white"
        >
          Allocate shares Pro Rata
        </button>
      );
    }

    return (
      <button
        onClick={handleGoToNextStep}
        className="bg-sflPrimary p-2 px-6 rounded text-white"
      >
        Proceed
      </button>
    );
  };

  useEffect(() => {
    if (selectedTabIndex === 0 && typeOfChange !== null) {
      setTabs(initialTabs);
    }
  }, [initialTabs, typeOfChange, selectedTabIndex]);

  useEffect(() => {
    if (selectedTabIndex + 1 === tabs.length) {
      setIsLastStep(true);
    }
    setSelectedTab(tabs[selectedTabIndex] || tabs[0]);
  }, [selectedTabIndex, tabs]);

  return (
    <div className="flex flex-col gap-2">
      {selectedTab?.id && (
        <>
          <div className="text-gray-900 py-3 flex justify-between items-center">
            <div>
              <h2 className="text-sm">
                Step {selectedTabIndex + 1} of {tabs.length}
              </h2>
              <h1 className="font-semibold text-xl">
                Share Capital / Offer Letters
              </h1>
            </div>
            {typeOfChange === "unallotedShares" &&
              selectedTab.id === "shareCapital" &&
              !showAddSharesForm &&
              !showAllotmentForm && (
                <>
                  {(company.type === "PVT" || company.type === "PLC") &&
                    hasProposedAllotment &&
                    preEmptionRights === "waived" && (
                      <button
                        onClick={handleRightsToIssueClick}
                        className="bg-sflPrimary p-3 px-4 rounded text-white mr-2"
                      >
                        Rights Issue | General Offer
                      </button>
                    )}
                </>
              )}
          </div>
          <Tabs
            selectedTabIndex={selectedTabIndex}
            setSelectedTabIndex={setSelectedTabIndex}
            tabs={tabs}
            tabsClickable={false}
          />
          <div>
            <div className="py-6">
              {selectedTab.id === "typeOfChange" ? (
                <TypeOfChange
                  setTypeOfChange={handleTypeOfChangeSelection}
                  typeOfChange={typeOfChange}
                />
              ) : selectedTab.id === "shareCapital" ? (
                showAddSharesForm ? (
                  <AddSharesOnOffer
                    id={company._id}
                    onCancel={hideAddSharesForm}
                    onSubmit={handleAddSharesOnOfferFormSubmit}
                    initialData={formData}
                    filteredOfficials={filteredOfficials}
                  />
                ) : showAllotmentForm ? (
                  <AllotmentForm
                    companyId={companyId}
                    entityType={company.type}
                    shareAllotments={shareAllotments}
                    selectedOption={selectedOption}
                    setSelectedOption={setSelectedOption}
                    mode={
                      selectedOption === "rightsIssue"
                        ? "rightsIssue"
                        : "proRata"
                    }
                    onSubmit={handleAllotmentFormSubmit}
                    onCancel={hideAllotmentForm}
                    onBack={hideAllotmentForm}
                    submittedAllocations={submittedAllocations}
                    onUpdateAllocations={setSubmittedAllocations}
                    deleteAllocationFromTransaction={
                      deleteAllocationFromTransaction
                    }
                  />
                ) : (
                  <ShareCapital
                    ref={shareCapitalRef}
                    typeOfChange={typeOfChange}
                  />
                )
              ) : selectedTab.id === "companyOfficial" ? (
                <CompanyOfficial />
              ) : selectedTab.id === "beneficialOwners" ? (
                <BeneficialOwners />
              ) : selectedTab.id === "resolutionsDirectors" ? (
                <ResolutionsDirectors />
              ) : selectedTab.id === "shareholders" ? (
                <Shareholders />
              ) : selectedTab.id === "status" ? (
                <Status />
              ) : null}
            </div>
            <div className="flex justify-between items-center">
              <div className="flex items-center">
                {selectedTabIndex !== 0 &&
                  !showAddSharesForm &&
                  !showAllotmentForm && (
                    <>
                      <span className="flex items-center mr-4 h-7">
                        <ChevronLeftIcon
                          className="flex-shrink-0 w-5 h-5"
                          aria-hidden="true"
                        />
                      </span>
                      <button onClick={handleGoToPrevStep}>Go Back</button>
                    </>
                  )}
              </div>
              {selectedTabIndex !== 0 &&
              !showAddSharesForm &&
              !showAllotmentForm
                ? renderBottomButtons()
                : null}
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default AllotmentOfShares;
